<template>
  <div class="smaller-container-wrapper">
    <Hero
      :title="$t('message.spotlightV2.getReportForm.title')"
      :text="$t('message.spotlightV2.getReportForm.text')"
    ></Hero>
    <mobialis-form-with-validation @onValidate="submit">
      <div>
        <mobialis-text-input-with-validation
          :rules="{ required: true, regex: /^([^0-9]*)$/ }"
          :label="$t('message.common.firstName')"
          v-model="user.firstName"
          vid="firstName"
          data-cy="firstName"
        ></mobialis-text-input-with-validation>
        <mobialis-text-input-with-validation
          :rules="{ required: true, regex: /^([^0-9]*)$/ }"
          :label="$t('message.common.lastName')"
          v-model="user.lastName"
          vid="lastName"
          data-cy="lastName"
        ></mobialis-text-input-with-validation>
        <mobialis-text-input-with-validation
          rules="required|email"
          :label="$t('message.common.emailAddress')"
          v-model="user.emailAddress"
          vid="emailAddress"
          data-cy="emailAddress"
        ></mobialis-text-input-with-validation>
        <mobialis-text-input-with-validation
          class="phone-number"
          rules="required|length:10"
          :label="$t('message.spotlightV2.getReportForm.mobilePhone')"
          v-model="user.phoneNumber"
          vid="phoneNumber"
          placeholder="(   )"
          mask-type="phoneNumber"
          type="tel"
          data-cy="phoneNumber"
        ></mobialis-text-input-with-validation>
        <mobialis-check-box-with-validation
          rules="required:true"
          :label="$t('message.spotlightV2.getReportForm.tandc', { dealershipName: getBusinessName })"
          vid="tandc"
          id="tandc"
          data-cy="tAndC"
        ></mobialis-check-box-with-validation>
      </div>
      <mobialis-button data-cy="submit" type="submit" class="my-5">{{
        $t('message.spotlightV2.getReportForm.buttonText')
      }}</mobialis-button>
    </mobialis-form-with-validation>
    <div class="avr-card">
      <h3>
        {{ $t('message.spotlightV2.getReportForm.privacyCard.title') }}
        <font-awesome-icon
          class="text-primary"
          :icon="['far', 'comment-alt-smile']"
          :style="{ width: '15px', paddingTop: '4px', marginLeft: '4px' }"
        ></font-awesome-icon>
      </h3>
      <p class="mb-0">{{ $t('message.spotlightV2.getReportForm.privacyCard.text') }}</p>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapGetters } from 'vuex';
import Hero from '@/modules/spotlight/components/Hero.vue';
import log from '@/services/log';
import { enumMixin } from '@/mixins';

export default {
  name: 'GetReport',
  mixins: [enumMixin],
  components: {
    Hero,
  },
  data() {
    return {
      user: cloneDeep(this.$store.state.user),
    };
  },
  computed: {
    ...mapGetters('business', ['getBusinessName']),
  },
  methods: {
    async submit(isValid) {
      if (!isValid) {
        return;
      }

      this.$store.commit('user/UPDATE_USER', this.user);

      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/createLead').catch(error => {
          // Handle an error for create lead
          log('Error in Spotlight report request form - Create lead', error);
          throw error;
        });

        // Push the route and update lead for route list
        this.$router.push(`/${this.baseRoute}/spotlight/report-sent`);

        await this.$store
          .dispatch('lead/updateLead', {
            step: this.enums.LeadStep.SPOTLIGHT,
          })
          .catch(error => {
            // Handle an error for update lead
            log('Error in Spotlight report request form - Update lead', error);
            throw error;
          });
      } catch (error) {
        this.$router.push({ name: `spotlight-error-${this.baseRoute}` });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.smaller-container-wrapper {
  margin-bottom: 106px;
}
.phone-number {
  width: 180px;
  white-space: nowrap;
}
.avr-card {
  padding: 24px;
  h3 {
    font-size: 20px;
    line-height: 25px;
  }
  p {
    max-width: 423px;
  }
}
</style>
